import { render, staticRenderFns } from "./mainData.vue?vue&type=template&id=72f7bc88&scoped=true&"
import script from "./mainData.vue?vue&type=script&lang=js&"
export * from "./mainData.vue?vue&type=script&lang=js&"
import style0 from "./mainData.vue?vue&type=style&index=0&id=72f7bc88&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f7bc88",
  null
  
)

export default component.exports